module.exports = __webpack_public_path__ + "h5/img/slot.fa761df1.jpg";